import { useMutation } from '@tanstack/react-query'
import { TwoFATypes } from 'pages/MyAccountEdit/types'
import { patchRequest } from 'utils/api/apiRequest'

type Data = {
  type: TwoFATypes[] | null
}

export const usePatchTwoFASetting = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: (payload: Data) => patchRequest(`/two-factor-settings`, payload),
    onSuccess: () => {
      onSuccess?.()
    },
  })
}
